






























import { NewObject } from "@/helper/shareHelper";
import { GetIconList } from "@/helper/classificationHelper";
import { IconClassificationItem, LoadingStatusType } from "@/enums/enums";
import { ClassificationItemListModel, ClassificationItemModel } from "@/model/classification";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreClassification = namespace("Classification");

@Component
export default class DropdownClassification extends Vue {
  @Prop({}) classificationTemplate!: any;
  private classificationItemList: any = [];
  private selectedClassificationItem: any = {
    name: this.$t("Not_Specified"),
    id: 0,
  };

  @StoreClassification.Getter
  private getClassificationItemLoadingStatus!: LoadingStatusType;

  @StoreClassification.Getter
  private getClassificationItemList!: Array<ClassificationItemModel>;

  @StoreClassification.Action
  private DoGetClassificationItemList!: (classificationId: number) => void;

  get isClassificationItemLoadingStatus() {
    return this.getClassificationItemLoadingStatus === LoadingStatusType.Loading;
  }

  @Watch("getClassificationItemLoadingStatus", { immediate: true })
  getClassificationItemLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.None) {
      this.DoGetClassificationItemList(this.classificationTemplate.classification.id);
    } else if (newVal == LoadingStatusType.Success) {
      if (this.getClassificationItemList.length > 0) {
        const classificationItem = this.getClassificationItemList.find(
          (x) => x.classificationId === this.classificationTemplate.classification.id
        );
        if (classificationItem) {
          this.SetClassificationItemList(classificationItem.classificationItemList);
        } else {
          this.DoGetClassificationItemList(this.classificationTemplate.classification.id);
        }
      }
    }
  }
  @Watch("selectedClassificationItem", { deep: true })
  getsSelectedClassificationItemChanged() {
    const classificationTemplateTemp = {
      classificationId: this.classificationTemplate.classification.id,
      classificationItemList: Array<ClassificationItemListModel>(),
      classification: this.classificationTemplate.classification,
      isSetDefaultValue: false,
    };
    classificationTemplateTemp.classificationItemList.push(NewObject(this.selectedClassificationItem));
    this.$emit("update:classificationTemplate", classificationTemplateTemp);
  }

  public SetClassificationItemList(classificationItemList: Array<ClassificationItemListModel>) {
    this.classificationItemList = [{ name: this.$t("Not_Specified"), id: 0 }];
    if (classificationItemList.length > 0) {
      classificationItemList.forEach((element) => {
        if (!element.isArchived) {
          this.classificationItemList.push(element);
        }
      });
    }
  }
  public GetIconName(iconType: IconClassificationItem) {
    if (iconType) {
      const iconList = GetIconList();
      const icon = iconList.find((x) => x.iconType == iconType);
      return icon ? icon.iconName : "";
    } else {
      return "";
    }
  }
}
